import { Link } from "wouter";
import { SCREENS } from "../../api/console";

/**
 * NO SCREEN AT THAT ADDRESS.
 *
 * The router used to answer every unmatched path with the Observability screen.
 * Two things went wrong with that. Signing in lands on `/`, so the console
 * opened showing Observability while the address bar said `/` and the
 * navigation highlighted nothing, because it matches on the exact href. And a
 * mistyped address quietly rendered a real screen, so there was no way to tell
 * a wrong URL from a right one.
 */
export function AdminNotFound({ path }: { readonly path: string }) {
  return (
    <div className="flex flex-col gap-space-md">
      <div className="flex flex-col gap-1">
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-on-surface-variant">
          404
        </span>
        <h1 className="font-headline-md text-headline-md font-bold text-on-surface">
          There is no console screen at that address
        </h1>
        <p className="font-body-md text-body-md text-on-surface-variant max-w-2xl">
          <code className="font-label-md text-label-md">{path}</code> does not name one of the
          screens below. Nothing is broken and nothing is missing.
        </p>
      </div>

      <ul className="flex flex-col gap-2 max-w-2xl">
        {SCREENS.map((screen) => (
          <li key={screen.href}>
            <Link
              className="flex flex-col gap-0.5 rounded-xl border border-outline-variant bg-surface-container-lowest p-space-md hover:bg-surface-container-low transition-colors"
              href={screen.href}
            >
              <span className="font-body-md text-body-md font-semibold text-on-surface">
                {screen.label}
              </span>
              <span className="font-body-sm text-body-sm text-on-surface-variant">
                {screen.hint}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
